export const approvalModal =
  (value = false, status) =>
  async (dispatch) => {
    await dispatch({
      type: "USER_APPROVE_MODAL",
      payload: { value, status }
    });
  };
